// @flow
import React from 'react';
import Copy from './styles';

type PropsType = {
  hide: boolean,
};

const SessionsListEmpty = ({ hide }: PropsType) =>
  !hide && (
    <div>
      <Copy>You haven&apos;t logged any sessions yet. Click Create Session to get started.</Copy>
    </div>
  );

export const EngagementEmpty = () => (
  <Copy>
    {"You don't have any students yet! Talk to your administrator to add students to your roster."}
  </Copy>
);

export default SessionsListEmpty;



// WEBPACK FOOTER //
// ./src/components/sessions/list/empty/index.js